/** ค่าที่ควรเป็น decimal string แต่ไม่ใช่ */
export class InvalidDecimalError extends Error {
  constructor(
    readonly field: string,
    readonly value: unknown,
  ) {
    super(`ค่าของ "${field}" ไม่ใช่ decimal string ที่ถูกต้อง: ${JSON.stringify(value)}`);
    this.name = 'InvalidDecimalError';
  }
}

/** หาอัตราแลกเปลี่ยนของคู่เงินที่ต้องการไม่เจอ */
export class FxRateMissingError extends Error {
  constructor(
    readonly from: string,
    readonly to: string,
  ) {
    super(`ไม่พบอัตราแลกเปลี่ยน ${from} → ${to}`);
    this.name = 'FxRateMissingError';
  }
}

/** การแก้ position ที่ไม่ถูกต้อง เช่น ซื้อเพิ่มด้วยจำนวนติดลบ หรือขายเกินที่ถืออยู่ */
export class InvalidPositionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidPositionError';
  }
}

/** ซื้อเพิ่ม/ขาย ด้วยสกุลเงินที่ไม่ตรงกับต้นทุนเดิม (spec Section 5.3) */
export class CurrencyMismatchError extends Error {
  constructor(
    readonly expected: string,
    readonly received: string,
  ) {
    super(`สกุลเงินไม่ตรงกัน: ต้นทุนเดิมเป็น ${expected} แต่ได้รับ ${received}`);
    this.name = 'CurrencyMismatchError';
  }
}
